export const LOGO_WIDTH = 70

export const LOGO_SMALL_WIDTH = 16

export const LOGO_HEIGHT = 22
